import { Component, OnInit } from '@angular/core';
import { label } from 'src/app/constants/labels';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  labels;
  currentYear: number;
  constructor() { }

  /**
   * Footer Page initialization
   * Creates footer component
   */ 
  ngOnInit() {
    // adding labels text
    this.labels = label;
    this.currentYear = new Date().getFullYear();
  }

}
